module.exports = __webpack_public_path__ + "img/medal8.a6533423.png";